import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const useAddPassageValidation = () => {
  const { formatMessage } = useLocale();
  const requiredMessage = formatMessage({ id: AppMessages['common.validation.required'] });

  const schema = yup.object().shape({
    rcpId: yup.string().required(requiredMessage),
    tkdId: yup.string().required(requiredMessage),
    mod: yup.string().required(requiredMessage),
    strefaPoczatkowaId: yup.string().required(requiredMessage),
    // Mirrors the backend's `PRZEJSCIE_TE_SAME_STREFY` (contract §2) so the user sees it before submitting.
    strefaKoncowaId: yup
      .string()
      .required(requiredMessage)
      .notOneOf(
        [yup.ref('strefaPoczatkowaId')],
        formatMessage({ id: AppMessages['definitions.passages.add.sameZones'] }),
      ),
  });

  return { schema };
};
